import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppState, useAppDispatch } from 'stores/type';
import { Splash } from 'views/components/molecules/Splash';
import { setExceptionError } from 'stores/errorSlice';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';
import { useDevice } from 'views/hooks/useDevice';

// BrowserRouter の props type を指定するのが難しいためESLintの警告を無視する
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const CheckSessionRouter = ({ ...props }): React.ReactElement => {
  const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector;
  const deviceFetched = useSelector((state) => state.deviceState.fetched);
  const dispatch = useAppDispatch();
  const { restore } = useDevice();
  useEffect(() => {
    restore().catch((e) => {
      dispatch(setExceptionError(e));
    });
  }, [dispatch, restore]);

  return deviceFetched ? (
    <BrowserRouter {...props} />
  ) : (
    <DefaultTemplate headerText="">
      <Splash />
    </DefaultTemplate>
  );
};
